<template>
  <v-sheet class="mx-auto" elevation="0" color="grey lighten-5">
    <v-subheader>Pulseras</v-subheader>
    <v-slide-group v-model="model">
      <v-slide-item v-for="n in 1" :key="n" v-slot:default="{ active, toggle }">
        <v-card
          :color="active ? 'primary' : 'white lighten-1'"
          class="mx-4 my-1"
          height="140"
          width="240"
          flat
          @click="showPulsera(n)"
        >
          <v-card-title>
            <v-row align="end" class="px-2">
              <v-spacer></v-spacer>
              <div>
                <span class="display-2">{{avg}}</span>
                <strong>€</strong>
              </div>
            </v-row>
          </v-card-title>

          <v-sheet color="transparent" class="fill-height">
            <v-sparkline
              :key="String(avg)"
              :smooth="8"
              color="pink"
              :line-width="10"
              :value="heartbeats"
              auto-draw
              stroke-linecap="round"
            ></v-sparkline>
          </v-sheet>
        </v-card>
      </v-slide-item>
      <v-slide-item>
        <v-card color="pink" class="mx-4 my-1" height="140" width="240" flat @click="addPulsera">
          <v-row class="fill-height" align="center" justify="center">
            <v-scale-transition>
              <v-icon color="white" size="48" v-text="'mdi-plus-circle-outline'"></v-icon>
            </v-scale-transition>
          </v-row>
        </v-card>
      </v-slide-item>
    </v-slide-group>
    <v-list three-line class="mt-4">
      <template v-for="(item, index) in items">
        <v-subheader v-if="item.header" :key="item.header" v-text="item.header"></v-subheader>

        <v-divider v-else-if="item.divider" :key="index" :inset="item.inset"></v-divider>

        <v-list-item v-else :key="item.title">
          <v-list-item-avatar>
            <v-img :src="item.avatar"></v-img>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title v-html="item.title"></v-list-item-title>
            <v-list-item-subtitle v-html="item.subtitle"></v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>

    <v-bottom-sheet inset v-model="scanCard" style="border-radius: 36px 36px 0px 0px">
      <v-sheet class="text-center" height="400" tile style="border-radius: 36px 36px 0px 0px">
        <Lottie
          class="animation pt-4"
          renderer="canvas"
          :loop="true"
          :autoplay="true"
          :animationData="lottieData"
          @getLottieInstance="getLottieInstance"
        />
      </v-sheet>
    </v-bottom-sheet>
  </v-sheet>
</template>

<script>
import Lottie from "vue-lottie-web";
import lottieData from "../../anim/ripple_pink_fast.json";

export default {
  data() {
    return {
      model: null,
      heartbeats: [],
      items: [
        { header: "Hoy" },
        {
          avatar: "https://cdn.vuetifyjs.com/images/lists/1.jpg",
          title: "Brunch this weekend?",
          subtitle:
            "<span class='text--primary'>Ali Connors</span> &mdash; I'll be in your neighborhood doing errands this weekend. Do you want to hang out?"
        },
        { divider: true, inset: true },
        {
          avatar: "https://cdn.vuetifyjs.com/images/lists/2.jpg",
          title: 'Summer BBQ <span class="grey--text text--lighten-1">4</span>',
          subtitle:
            "<span class='text--primary'>to Alex, Scott, Jennifer</span> &mdash; Wish I could come, but I'm out of town this weekend."
        },
        { divider: true, inset: true },
        {
          avatar: "https://cdn.vuetifyjs.com/images/lists/3.jpg",
          title: "Oui oui",
          subtitle:
            "<span class='text--primary'>Sandra Adams</span> &mdash; Do you have Paris recommendations? Have you ever been?"
        },
        { divider: true, inset: true },
        {
          avatar: "https://cdn.vuetifyjs.com/images/lists/4.jpg",
          title: "Birthday gift",
          subtitle:
            "<span class='text--primary'>Trevor Hansen</span> &mdash; Have any ideas about what we should get Heidi for her birthday?"
        },
        { divider: true, inset: true },
        {
          avatar: "https://cdn.vuetifyjs.com/images/lists/5.jpg",
          title: "Recipe to try",
          subtitle:
            "<span class='text--primary'>Britta Holt</span> &mdash; We should eat this: Grate, Squash, Corn, and tomatillo Tacos."
        }
      ],
      lottieData,
      lottieInstance: "",
      scanCard: false,
    };
  },
  components: {
      Lottie
  },
  computed: {
    avg() {
      const sum = this.heartbeats.reduce((acc, cur) => acc + cur, 0);
      const length = this.heartbeats.length;

      if (!sum && !length) return 0;

      return Math.ceil(sum / length);
    }
  },
  methods: {
    addPulsera() {

        this.scanCard = true;
    },
    showPulsera() {
      this.$router.push({ path: "/about" });
    },
    heartbeat() {
      return Math.ceil(Math.random() * (120 - 80) + 80);
    },
    getLottieInstance(lottieInstance) {
      this.lottieInstance = lottieInstance;
    }
  },
  created() {
    this.heartbeats = Array.from({ length: 20 }, this.heartbeat);
  }
};
</script>

<style>
</style>